var map = {
	"./alpes/1.jpg": "63ed",
	"./alpes/2.jpg": "58ee",
	"./alpes/3.jpg": "a322",
	"./alpes/4.jpg": "ea7d",
	"./alpes/5.jpg": "5d12",
	"./alpes/6.jpg": "ff48",
	"./alpes/7.jpg": "01ec",
	"./brunch/LaBase-Club-600px.jpg": "447c",
	"./brunch/LaBase-Gnocchi-Sorrento-600px(2).jpg": "2feda",
	"./brunch/LaBase-Latte-Amaretto-600px.jpg": "e87f",
	"./brunch/LaBase-PanCakes-600px.jpg": "bc3e",
	"./brunch/LaBase-Portofino-600px(2).jpg": "2847",
	"./brunch/double_sand.jpg": "e5ce",
	"./brunch/egg_cheese.jpg": "fc97",
	"./brunch/egg_cheese_diff.jpg": "9c1e",
	"./brunch/glasses.jpg": "47da",
	"./brunch/hot_chicken.jpg": "c444",
	"./brunch/pancakes.jpg": "70dd",
	"./brunch/tiles.jpg": "ce73",
	"./day/LaBase-Mojito-Cup-Cake-600px.jpg": "2f6f",
	"./day/LaBase-SaladeCésar-600px.jpg": "5a72",
	"./day/LaBase-Suppli-Alla-Romana-600px.jpg": "15f8",
	"./day/LaBase-Waikiki-600px.jpg": "82a9",
	"./day/breaking_cheese.jpg": "e2c6",
	"./day/cheese_pan.jpg": "5012",
	"./day/coffee.jpg": "5fd2",
	"./day/counter.jpg": "ea32",
	"./day/glasses.jpg": "840e",
	"./day/grilled_cheese.jpg": "531a",
	"./day/parmesen.jpg": "4ec7",
	"./day/plate_cheese.jpg": "cded",
	"./day/teas.jpg": "8ae0",
	"./grilledcheese/Hot-cheezken-Max-Quality.jpg": "9094",
	"./grilledcheese/La-base-Beyrouth-Max-Quality.jpg": "a4cb",
	"./grilledcheese/La-base-verdun-Max-Quality.jpg": "d886",
	"./grilledcheese/Loulou-Max-Quality.jpg": "eeea",
	"./grilledcheese/Martin-Matin-Max-Quality.jpg": "1a02",
	"./grilledcheese/Nikki-Max-Quality.jpg": "8dd4",
	"./mambo/Burger-El-Cubano-Max-Quality.jpg": "7cc5",
	"./mambo/Burger-du-sommet-Max-Quality.jpg": "6f8b",
	"./mambo/LaBase-BurgerMoorea-600px.jpg": "63b1",
	"./mambo/LaBase-Edo-burger-600.jpg": "f5a8",
	"./mambo/LaBase-Marrakech-burger-600.jpg": "9acf",
	"./mambo/LaBase-Mole-burger-600.jpg": "2049",
	"./mambo/LaBase-Sorrento-Burger-600px.jpg": "9a4f",
	"./mambo/LaBase-Sorrento-Vege-Burger-600px.jpg": "eb7f",
	"./mambo/palmiers.png": "d0b9",
	"./night/LaBase-Portofino-600px.jpg": "3e5c",
	"./night/cabaret_poulet.jpg": "7640",
	"./night/glasses.jpg": "4af3",
	"./night/logo.jpg": "7088",
	"./night/poulet_pois.jpg": "816f",
	"./night/poulet_pois_top.jpg": "37d1",
	"./sapori/sapori_foot.jpg": "3284"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1310";